export default __webpack_public_path__ + "static/media/guppy-mini.8ea71c83.jpg";